import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$keys from 'babel-runtime/core-js/object/keys';
export var appendToUrl = function appendToUrl(url, params) {
  _Object$keys(params).forEach(function (key, index) {
    var isQuestionMarkPresent = url && url.indexOf('?') !== -1;
    var separator = isQuestionMarkPresent ? '&' : '?';
    url += '' + separator + key + '=' + encodeURIComponent(params[key]);
  });
  return url;
};

export var makeContextHeaders = function makeContextHeaders(context) {
  var headers = void 0;
  if (context) {
    headers = { 'Gipsy-Context': _JSON$stringify(context) };
  }
  return headers;
};
//# sourceMappingURL=request.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/request.js
// module id = 774
// module chunks = 0